import { combineReducers } from 'redux'
import { FacebookState, facebookReducer } from './facebook/facebook.reducer'
import { InstagramState, instagramReducer } from './instagram/instagram.reducer'
import { CommonState, CommonReducer } from './common/common.reducer'
import { googleMyBusinessReducer, GoogleMyBusinessState } from './googleMyBusiness/googleMyBusiness.reducer'
import { linkedInReducer, LinkedInState } from './linkedIn/linkedIn.reducer'

export interface ApiError {
  [key: string]: Response | Error | Record<string, unknown> | undefined
}

export interface NetworkContentRootState {
  facebookStore: FacebookState
  instagramStore: InstagramState
  googleMyBusinessStore: GoogleMyBusinessState
  commonStore: CommonState
  linkedInStore: LinkedInState
}

export const networkContentRootReducer = combineReducers<NetworkContentRootState>({
  facebookStore: facebookReducer,
  instagramStore: instagramReducer,
  googleMyBusinessStore: googleMyBusinessReducer,
  commonStore: CommonReducer,
  linkedInStore: linkedInReducer,
})
